import {Component, isDevMode, OnDestroy, OnInit} from '@angular/core';
import {DataConfig} from '../../../shared/models/tabs-data';
import {combineLatest, Observable, Subscription} from 'rxjs';
import {Company, CompanyForm} from '../../models/company';
import {CompanyEditAction} from '../../actions/company-edit';
import {Store} from '@ngrx/store';
import * as fromCompanies from '../../reducers';
import {ActivatedRoute, Router} from '@angular/router';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {FormGroup} from '@angular/forms';
import {FindInvalidControlsService} from '../../../shared/services/find-invalid-controls.service';
import {DeleteCompanyAction} from '../../actions/company-delete';
import {AddCompanyAction} from '../../actions/company-add';
import * as fromRoot from '../../../shared/reducers';
import {FooterDetails} from '../../../order/models/footer-extra-info';
import {ModalComponent} from '@storever/modal-confirmation';
import {MergeSiteAction} from '../../../site/actions/merge-site-of-client';
import {L10nTranslationService} from 'angular-l10n';

@Component({
  selector: 'storever-company-display',
  templateUrl: './company-display.component.html',
  styleUrls: ['./company-display.component.scss']
})
export class CompanyDisplayComponent implements OnInit, OnDestroy {
  dataConfig: DataConfig;
  content: Observable<CompanyForm>;
  private sub$: Subscription;
  private subscriptions = [];
  isLoading = true;
  company: CompanyForm;
  currentCompanyUuid: string;
  error: FooterDetails[];
  bsModalRef: BsModalRef;
  constructor(private storeCompany: Store<fromCompanies.AppState>,
              private activatedRoute: ActivatedRoute,
              private storeRoot: Store<fromRoot.AppState>,
              private modalService: BsModalService,
              private translation: L10nTranslationService,
              private findInvalidControlsService: FindInvalidControlsService,
              private router: Router) { }
  get isAdd(): boolean {
    return this.activatedRoute.snapshot.routeConfig.path === 'add'
  }
  get isEdit(): boolean {
    return this.activatedRoute.snapshot.routeConfig.path === 'detail/:companyId'
  }
  ngOnInit(): void {
    this.dataConfig.form.disable();
    this.content = this.dataConfig.content;
    this.sub$ = this.content.subscribe((company: CompanyForm) => {
      if (company && this.dataConfig && this.dataConfig.form) {
        this.company = company;
        this.currentCompanyUuid = company.uuid;
        this.patchValue(company);
        this.isLoading = false;
        }
    });
    this.subscriptions.push(this.sub$);
    if (this.isAdd) {
      this.isLoading = false;
      this.dataConfig.form.enable();
      this.dataConfig.form.get(['general' , 'active']).patchValue(true)
    }
  }

  save(apiName: string): void {
    let patchType = apiName;
    const resp = this.dataConfig.form.getRawValue();
    if ( apiName === 'billing' && resp.billing.sapCode) {
      patchType = 'simple';
    }
    this.storeCompany.dispatch(new CompanyEditAction({
      apiName: patchType ,
      companyUuid: this.company.uuid ,
      company: resp,
    }));
    this.dataConfig.form.markAsUntouched();
    this.dataConfig.form.markAsPristine();
    this.dataConfig.form.disable({ emitEvent: false });
  }
  undo(formPath: string[]): void {}
  patchValue(value: CompanyForm): void {
     this.dataConfig.form.patchValue({
       address: value.address ? value.address : '',
       contact: value.contact ? value.contact : '',
       general: value.general ? value.general : '',
       misc: value.misc ? value.misc : '',
       billing: value.billing ? value.billing : '',
       uuid: value.uuid ? value.uuid : '',
     });
     if (value && value.address && value.address.country) {
       this.dataConfig.form.get(['address', 'countryForm', 'name']).patchValue(value.address.country);
     }

   }
  ngOnDestroy(): void {
    this.dataConfig.form.reset();
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }
  getInvalidControls(form: FormGroup): string[] {
    if (isDevMode()) {
      return this.findInvalidControlsService.find(form);
    }
  }
  cancel(): void  {


    const initialState = {
      title: 'CONFIRMATION',
      message: 'Are you sure you want to delete this company?',
      variable: null,
      deleteBtn: false,
      hideBtnOk: true
    };
    this.bsModalRef = this.modalService.show(ModalComponent, {initialState});
    this.sub$ = combineLatest(this.modalService.onHide).subscribe(() => {
      if (this.bsModalRef.content.isConfirmed) {
        this.storeRoot.dispatch(new DeleteCompanyAction(this.currentCompanyUuid));
      }

    });
    this.subscriptions.push(this.sub$);
  }
  resetForm(form: FormGroup): void  {
    form.reset();
  }
  saveGlobal(value: boolean, form: FormGroup): void {
    const resp = form.getRawValue();
    this.storeRoot.dispatch(new AddCompanyAction(resp));
  }
}
